import {openWindow} from '../../../../common/openWindow.function';

export function openAutoCharge(returnUrl = '') {
  openWindow({
    url: `/relay/autocharge?returnUrl=${encodeURIComponent(returnUrl)}`,
    target: 'autocharge',
    features: 'width=460, height=700',
  });
}
